import React from "react"
import circle1 from "../images/circle-1-inverted.png";
import underline from "../images/underline-4.png";
const Header = ({ siteTitle, navi }) => (<>
  <header className="site__nav">
      <ul className="site__navbar" data-location={siteTitle}>
          <li className="p-200"><a className="site__navbar-link site__navbar-link--tl" href="http://127.0.0.1:8000/" onClick={e => { e.preventDefault(); navi.nav('/'); }}>
              LUCA NARDI
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 147 6"
                   data-animated-mark="underline-4" data-js-module="" className="draw">
                  <defs>
                      <pattern id="underline-4" patternUnits="userSpaceOnUse" width="100%" height="100%">
                          <image xlinkHref={underline}></image>
                      </pattern>
                  </defs>
                  <path fill="none" stroke="url(#underline-4)" className="todraw" strokeWidth="6" d="M-2.3,3C48.3,3.1,98.9,3.1,149.5,3.2"></path>
              </svg>
          </a></li>
          <li className="p-200"><a className="site__navbar-link site__navbar-link--tr" href="http://127.0.0.1:8000/" onClick={e => { e.preventDefault(); navi.nav('/about/'); }}>
              ABOUT
              <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 297 152"
                   className="">
                  <defs>
                      <pattern  id="black-circle-2" patternUnits="userSpaceOnUse" width="100%" height="100%">
                          <image filter="#spotlight" xlinkHref={circle1}></image>
                      </pattern>
                  </defs>
                  <path className="todraw" fill="none" stroke="url(#black-circle-2)" strokeWidth="9"
                        d="M170.2,33c-5.4-3.2-13.7-7.5-24.5-10.2c-29.5-7.5-54.2,3.6-72,9.5c-21,7-45.5,21-61.2,41.8 c-2.8,3.7-13.8,25.8-3.8,45.2c7,13.5,18.3,18.4,30.2,22.8c6.4,2.4,39.2,10,69,5.5c39.6-6,58.4-12.6,83.5-26.5 c29.6-16.4,38.4-22.9,53-40.7c6-7.3,9.3-20.5,4-35.3c-6.5-18.3-25.3-26.4-41.2-32.7c-22.9-9.1-42.5-8.8-61.2-9 c-31.1-0.3-53.7,5.4-61.2,7.5c-17,4.7-31.6,8.8-46.8,20.8C27.2,40,13,51.1,11.5,68.8C9.7,89.3,25.8,105.4,29.8,108 c17.7,11.5,31.9,17.4,65.8,21c35.1,3.8,61.9-0.2,71.5-1.2c32.9-3.6,57.4-11.3,66.8-14.5c27.1-9.2,49.4-21,66.8-32"></path>
              </svg>
          </a></li>
      </ul>
  </header>
</>)

export default Header
